import React from 'react';
import { Spinner } from 'reactstrap';

const Loader = ({ message = "Loading Playbook..." }) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: '#f8f9fa', // Light gray background
      }}
    >
      <Spinner
        style={{
          width: '3rem',
          height: '3rem',
          color: '#007bff', // Bootstrap primary color
        }}
      />
      <p style={{ marginTop: '1rem', fontSize: '1.25rem', color: '#495057' }}>
        {message}
      </p>
    </div>
  );
};

export default Loader;
